/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SimpleStudyCycleEnum {
    Bachelor = 'Bachelor',
    Master = 'Master',
    Doctorate = 'Doctorate'
}

export function SimpleStudyCycleEnumFromJSON(json: any): SimpleStudyCycleEnum {
    return SimpleStudyCycleEnumFromJSONTyped(json, false);
}

export function SimpleStudyCycleEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleStudyCycleEnum {
    return json as SimpleStudyCycleEnum;
}

export function SimpleStudyCycleEnumToJSON(value?: SimpleStudyCycleEnum | null): any {
    return value as any;
}

